import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    FEATURED_MATCHES_BASE_CLASS,
    FEATURED_MATCHES_LAYOUT,
    UPCOMING_MATCHES_LAYOUT,
} from '../constants';
import {
    mapStateToProps,
    mapDispatchToProps,
} from '../../CommonDataListEvents/utils/utils';
import '../../CommonDataListEvents/styles/featured-matches-widget.scss';
import '../../SportsWidget/styles/sports-widget.scss';
import { getWidgetDataUrl } from '../utils';
import FeaturedMatchesLayout from '../layouts/FeaturedMatchesLayout';
import UpcomingMatchesLayout from '../layouts/UpcomingMatchesLayout';
import { getCountryIso } from '../../../../../../src/shared/utils/user';

export class FeaturedMatchesWidgetContainer extends React.Component {
    constructor() {
        super();

        this.createLayout = this.createLayout.bind(this);
        this.state = {
            dataLoading: true,
        };
    }

    static propTypes = {
        layout: PropTypes.string,
        sport: PropTypes.string,
        category: PropTypes.string,
        tournament: PropTypes.string,
        widgetHeader: PropTypes.string,
        originalWidgetLabel: PropTypes.string,
        widgetLabel: PropTypes.string,
        events: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array,
        ]),
        getWidgetEvents: PropTypes.func,
        stopListeningForUpdates: PropTypes.func,
        commonDataEvents: PropTypes.object,
        updateCommonStoreWsData: PropTypes.func,
        source: PropTypes.string,
        metaData: PropTypes.object,
        isCompetition: PropTypes.bool,
    };

    createLayout({
            layout,
            sport,
            widgetHeader,
            events,
            commonDataEvents,
            source,
            metaData,
            tournament,
            category,
            localizedSport,
            tournamentId,
            isCompetition,
        }) {

        /**
         * Temporary fix.
         * SportsV1 only supported adding football events from an inplay_start websocket message
         * @todo AM-4687
         */
        const websocketAddedEvents = [];
        const commonDataEventsFiltered = {};
        Object.keys(commonDataEvents).forEach((eId) => {
            if (commonDataEvents[eId].addedFromWs) {
                websocketAddedEvents.push(eId);

                return;
            }

            commonDataEventsFiltered[eId] = { ...commonDataEvents[eId] };
        });
        // can be Object or Array :-/
        const eventsFiltered = Object.values(events).filter(({ event_id: eId }) => (!websocketAddedEvents.includes(eId)));

        switch (layout) {
            case FEATURED_MATCHES_LAYOUT:
                return (
                    <FeaturedMatchesLayout
                        sport={sport}
                        widgetHeader={widgetHeader}
                        events={eventsFiltered}
                        commonDataEvents={commonDataEventsFiltered}
                        source={source} />
                );
            case UPCOMING_MATCHES_LAYOUT:
                return (
                    <UpcomingMatchesLayout
                        sport={sport}
                        widgetHeader={widgetHeader}
                        events={eventsFiltered}
                        commonDataEvents={commonDataEventsFiltered}
                        source={source}
                        tournament={tournament}
                        category={category}
                        matchRequestLimit={metaData.matchRequestLimit}
                        localizedSport={localizedSport}
                        tournamentId={tournamentId}
                        isCompetition={isCompetition}
                        />
                );

            default:
                return null;
        }
    }

    /**
     * After init DOM component, load page data
     * @returns {void}
     */
    componentDidMount() {
       this.refreshBets(true);
    }

    componentWillUnmount() {
        this.props.stopListeningForUpdates();
    }

    async refreshBets(fromBE) {
        if (fromBE) {
            let postParams = {
                country: getCountryIso(),
            };
            if (this.props.category) {
                postParams.category_slug = this.props.category;
            }
            if (this.props.tournament) {
                postParams.tournament_slug = this.props.tournament;
            }
            if (this.props.originalWidgetLabel) {
                postParams.widget_label = this.props.originalWidgetLabel;
            }
            await this.props.getWidgetEvents(
                this.props.updateCommonStoreWsData,
                getWidgetDataUrl(this.props.layout, this.props.sport),
                postParams
            )
            .then(() => this.setState({dataLoading: false}));
        } else {
            const waitMs = 500;
            await new Promise(resolve => setTimeout(() => {
                resolve();
            }, waitMs));
        }
        this.refreshBets.fetched = true;
    }

    /**
     * Render the component
     * @returns {JSX.Element} Returns a React Element
     */
    render() {
        if (this.state.dataLoading) {
            return null;
        }

        return <div className={FEATURED_MATCHES_BASE_CLASS}>{this.createLayout(this.props)}</div>;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedMatchesWidgetContainer);
